import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { LocalStoreService } from '@frontend/vanilla/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';

import { IBetslipRootState } from '../../../../base/store/state';
import { BetslipType } from '../../../../core/betslip-type';
import { BetslipPick } from '../../../../core/picks/betslip-pick';
import { BETSLIP_TYPE_PROVIDER } from '../../../../digital/services/betslip-type-provider.service';
import { SlipId } from '../../../bet-generation/models';
import { getTeaserSlipId } from '../../../bet-generation/services/slip.utils';
import { BetslipTeaserActions } from '../../actions';
import { LinearTeaserExpandedLocalStorageKey } from '../../models';

@Component({
    selector: 'bs-teaser-bet-linear',
    templateUrl: './teaser-bet-linear.component.html',
    styleUrls: ['./teaser-bet-linear.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ provide: BETSLIP_TYPE_PROVIDER, useValue: new BehaviorSubject(BetslipType.Teaser).asObservable() }],
    standalone: false,
})
export default class TeaserBetLinearComponent {
    @HostBinding('class') className = 'teaser-bet-linear';

    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() pickList: BetslipPick[];

    slipId: SlipId;
    defaultExpanded = false;
    betslipType = BetslipType.Teaser;

    constructor(
        public sitecore: Sitecore,
        localStorage: LocalStoreService,
        private store: Store<IBetslipRootState>,
    ) {
        this.slipId = getTeaserSlipId();
        this.defaultExpanded = !!localStorage.get(LinearTeaserExpandedLocalStorageKey);
    }

    toggleExpand(isExpanded: boolean): void {
        this.store.dispatch(BetslipTeaserActions.clickExpandLinearTeaserBet({ isExpanded }));
    }
}
